<template>
  <v-row align="center" no-gutters style="flex-wrap: nowrap;">
    <v-btn icon small @click="$emit('change')">
      <v-icon small>fa-sync-alt</v-icon>
    </v-btn>
    <v-autocomplete
      v-if="useTags === false"
      filled
      class="no-before"
      label="Catégorie"
      dense
      single-line
      hide-details
      :value="category"
      @change="
        v => {
          $emit('update:category', v);
          $emit('change', v);
        }
      "
      :items="getTagCategories"
      item-text="name"
      item-value="name"
    ></v-autocomplete>
    <InventoryTemplateTagsEditor
      v-if="useTags === true"
      filled
      class="no-before"
      dense
      hide-details
      single-line
      :solo="false"
      :solo-inverted="false"
      :icon="false"
      :value="tags"
      @input="
        v => {
          $emit('update:tags', v);
          $emit('change', v);
        }
      "
    >
    </InventoryTemplateTagsEditor>
    <v-btn text @click="$emit('update:useTags', !useTags)">
      <v-icon x-small class="mr-1">fa-exchange-alt</v-icon>
      <v-icon v-if="useTags === false" small>fa-hashtag</v-icon>
      <v-icon v-else small>fa-filter</v-icon>
    </v-btn>
  </v-row>
</template>

<script>
import { InventoryTemplateTagsEditor } from "@/modules/Inventory/components";
import { mapGetters } from "vuex";
export default {
  name: "AnalycticTransactionChartFilter",
  components: {
    InventoryTemplateTagsEditor
  },
  props: {
    category: {
      type: String,
      required: true
    },
    tags: {
      type: Array,
      required: true
    },
    useTags: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    ...mapGetters(["getTagCategories"])
  }
};
</script>

<style></style>
